import React, { useEffect, useState, useRef } from "react";

import { Label } from "reactstrap";

//Unform e componentes
import { useField } from "@unform/core";
import TooltipItem from "../TooltipItem";

//Common
import { SHOW_DESC_OBRIGATORIO_FIELDS } from "@/common/constantes";

//Utils
import { ICONES_MENSAGEM } from "@/frontend/utils/icones";

export default function URadio({
  name,
  label,
  data,
  defaultChecked,
  disabledValue = false,
  pularLinha = false,
  capitalizar = true,
  sm = false, //true: label e opções com o texto menor (texto-menor)
  value,
  onChange,
  ...rest
}) {
  const inputRefs = useRef([]);
  const { fieldName, registerField, defaultValue = "", error } = useField(name);

  const isControlled = value !== undefined;

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRefs,

      getValue: (refs) =>
        refs.current.find((input) => input?.checked)?.value || "",

      setValue: (refs, val) => {
        // const inputRef = refs.current.find((ref) => ref.value === String(val));
        // if (inputRef) inputRef.checked = true;

        // Desmarca todos
        refs.current.forEach((ref) => {
          if (ref) ref.checked = false;
        });

        // Se houver valor, marca o correspondente
        if (val !== null && val !== undefined && val !== "") {
          const inputRef = refs.current.find(
            (ref) => ref.value === String(val),
          );

          if (inputRef) inputRef.checked = true;
        }
      },

      clearValue: (refs) => {
        const inputRef = refs.current.find((ref) => ref.checked);
        if (inputRef) inputRef.checked = false;
      },
    });
  }, [fieldName, registerField]);

  function handleChange(event) {
    if (onChange) onChange(event);
  }

  return (
    <div>
      {label && (
        <Label htmlFor={fieldName} className={sm ? "texto-menor" : undefined}>
          {label}
        </Label>
      )}

      <div
        className={`${pularLinha ? "d-flex flex-wrap" : "d-flex"} ${
          error && SHOW_DESC_OBRIGATORIO_FIELDS == false
            ? "border border-danger rounded"
            : ""
        }`}
      >
        {data.map((option, index) => {
          const checkedValue =
            String(isControlled ? value : (defaultChecked ?? defaultValue)) ===
            String(option.value);

          return (
            <React.Fragment key={index}>
              <div>
                <label htmlFor={name}>
                  <div className="d-flex align-items-center pb-1 px-2">
                    {(option?.icone && checkedValue && (
                      <>
                        <span>{option?.icone}</span>
                        &nbsp;
                        <span className={sm ? "texto-menor" : undefined}>
                          {capitalizar
                            ? option.label.charAt(0).toUpperCase() +
                              option.label.slice(1).toLowerCase()
                            : option.label}
                        </span>
                      </>
                    )) || (
                      <>
                        <div className="d-flex">
                          <input
                            type="radio"
                            ref={(ref) => {
                              inputRefs.current[index] = ref;
                            }}
                            name={fieldName}
                            value={option.value}
                            disabled={disabledValue == option.value}
                            onChange={handleChange}
                            {...rest}
                            {...(isControlled
                              ? { checked: checkedValue }
                              : {
                                  defaultChecked: checkedValue,
                                })}
                          />
                          &nbsp;
                          {(option?.src && (
                            <span className="avatar">
                              <img src={option.src} alt="" />
                            </span>
                          )) || (
                            <span className={sm ? "texto-menor" : undefined}>
                              {capitalizar
                                ? option.label.charAt(0).toUpperCase() +
                                  option.label.slice(1).toLowerCase()
                                : option.label}
                            </span>
                          )}
                          {option?.textTip && (
                            //O ícone acompanha a altura do texto da opção (mesmo tamanho de letra) e fica centralizado nela
                            <span
                              className={`ms-1 d-flex align-items-center${sm ? " texto-menor" : ""}`}
                            >
                              <TooltipItem
                                text={option.textTip}
                                className="d-flex"
                              >
                                {option?.showInfo
                                  ? ICONES_MENSAGEM.INFO
                                  : ICONES_MENSAGEM.AJUDA}
                              </TooltipItem>
                            </span>
                          )}
                          {option?.espaco == true && (
                            <div className="me-3"></div>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                </label>
              </div>

              {option?.pular_linha && <div className="w-100" />}
            </React.Fragment>
          );
        })}
      </div>

      {error && SHOW_DESC_OBRIGATORIO_FIELDS == true && (
        <small className="text-danger">{error}</small>
      )}
    </div>
  );
}
